import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, HostListener } from '@angular/core';
import { cbseScienceGrade } from '@app-constants/app.constants';
import { Observable } from 'rxjs';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ClassModel } from 'src/app/model/class';
import { checkCBSEGr8 } from '@app-helpers/functions';
import { ClassService } from 'src/app/core/services/class.service';
@Component({
  selector: 'app-class-card',
  templateUrl: './class-card.component.html',
  styleUrls: ['./class-card.component.css']
})
export class ClassCardComponent implements OnInit, OnDestroy {
@Input() classData : ClassModel | any;
@Input() dataType: any;
@Input() classType:any;
@Input() index:number;
@Output() actionOnClick= new EventEmitter<any>();
isTomorrow = false;
isDropup = true;
isLive = false;
isToday = false;
set: any = '';
videoId: any;
cronjob: any;
timerId:any;
timeObj:any;
teacherNameChar:number = 20;
teacherDesChar = 72;
detailsClass: string = 'hide';
detailsIndex: number;
showScience: boolean = false;
classEndClear: any
  constructor(
    public _eventHandlingService:EventHandlingService,
    public _helper: HelperService,
    private classService: ClassService
  ) {}

  ngOnInit(): void {
    this.cardChangesOnResolution();
    this.checkStatus();
    this.showScience = checkCBSEGr8();
    this.checkteacherNotEndedClass(this.classData);
    }

    checkStatus(){

      if(this.dataType != 'past'){
        this.isToday = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
        if(this.isToday){
         this.cronjob = UtilityService.liveClassCounter( this.classData.serverTime , this.classData?.obj?.startTime, this.classData?.obj?.endTime)
         let liveat:any;

         if(this.cronjob?.ediff >= 0){

          liveat =  setTimeout(() => {
            this.isLive = true;
             }, this.classData?.classtype?.replace(' ','')?.toLowerCase() === 'courseclass' ? (this.cronjob?.sdiff-300000) : this.cronjob?.sdiff);
             let  livetill = setTimeout(() => {
               if (this.classData?.meeting?.status === 'ended') {
                this.isLive =  false;
                this._eventHandlingService.changeClassStatus('endClass');
                clearTimeout(livetill);
                clearTimeout(liveat);
               }
           }, this.cronjob?.ediff);

            } else if(this.cronjob?.sdiff <= 0 && this.cronjob?.ediff >= 0){
              this.isLive =  true;
            } else if(this.cronjob?.ediff == 0) {
              this.isLive =  false;

          }
        }else {
          this.statusCheck()
        }
      }


    }

    cardChangesOnResolution(){
      if(window.innerWidth <= 767){
        this.teacherNameChar = 16;
        this.teacherDesChar = 60;
      } else {
        this.teacherNameChar = 20;
        this.teacherDesChar = 72;
      }
     }

    @HostListener('window:resize', ['$event'])
    onResize(event:any) {
      if(event.target.innerWidth <= 767){
        this.teacherNameChar = 16;
        this.teacherDesChar = 60;
      } else {
        this.teacherNameChar = 20;
        this.teacherDesChar = 72;
      }

    }



    statusCheck(){

      if(!this.isToday){
      this.isTomorrow = UtilityService.isTomorrow(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      }
    }

  clickAction(type:string){
    if(type == 'rewatch'){
      let urlArray;
      urlArray = this.classData.recording[0].split('/');
      this.videoId = urlArray[urlArray.length - 1];

    }
  }


  ngOnDestroy(){
    clearInterval(this.timerId)
  }

  showHideDetails(val, index) {
    this.detailsClass = val;
    this.detailsIndex = index;
  }

  checkteacherNotEndedClass(classData) {
    if (classData?.meeting?.status === 'started') {
      this.isLive = true;
    }
  }
}


